const apikey = {
  xapikey: "y29gwmfNNj4ALv9jE5Hzk3V3CBUsMOnaaexsS4fO"
};

export default apikey;